import { Component, OnInit } from '@angular/core';
import { IDataStudioPark } from 'app/data-studio-redesign/interfaces/data-studio.interface';
import { QUERY_VIEW_PAGES } from 'app/data-studio-redesign/services/data-analysis-helper';
import { DataStudioService } from 'app/shared/services/data-services/data-studio/data-studio.service';
import { Observable, combineLatest } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';

@Component({
    selector: 'app-data-analysis',
    templateUrl: './data-analysis.component.html',
    styleUrls: ['./data-analysis.component.scss'],
    standalone: false
})
export class DataAnalysisComponent implements OnInit  {

  public queryView: string;
  public scatterPlotView: boolean = false;
  public dataSource;
  public dataSourceShared;
  public queryId: string;
  public viewIndex: number;
  public parks$: Observable<IDataStudioPark[]>;
  public creatingQuery: boolean;
  public creatingSharedQuery: boolean;
  public myQueriesView: boolean;
  public totalMyQueries: number;
  public totalSharedQueries: number;
  public pageSize: number = 10;
  public queryViewPages = QUERY_VIEW_PAGES;

  constructor(private dataStudioService: DataStudioService) { }

  public ngOnInit(): void {
    this.parks$ = this.dataStudioService.getDataAnalysisParkTurbineSignal('s10m');
    this.getQueriesList();
    this.viewIndex = 0;
    this.queryView = this.queryViewPages[3];
  }

  public back() {
    this.queryView = this.queryViewPages[3];
    this.getQueriesList();
  }

  public deleteQuery(id) {
    this.dataStudioService.deleteQuery(id).subscribe(success => success && this.getQueriesList());
  }

  public addNewQuery() {}

  public changeView({id, viewIndex, myQueriesView, queryView}) {
    this.queryId = id;
    this.viewIndex = viewIndex;
    this.queryView = queryView;
    this.myQueriesView = myQueriesView;
  }

  public updateList() {
    this.queryView = this.queryViewPages[3];
    this.getQueriesList();
  }

  public createQuery(queryData) {
    const { _id: id, title, period, granularity, startTs, endTs, isSharedQuery, queryType } = queryData;
    const query = { title, period, granularity, startTs, endTs, isSharedQuery, queryType };
    this.creatingQuery = !isSharedQuery;
    this.creatingSharedQuery = isSharedQuery;
    this.dataStudioService.getQuerySeries(id)
    .pipe(switchMap(series => {
      return this.dataStudioService.createQuery({...query, series})
      .pipe(switchMap((data) => {
        const queries$ = isSharedQuery ? this.dataStudioService.getSharedQueries() : this.dataStudioService.getQueries();
        return data && queries$;
      }))
    }))
    .subscribe(data => {
      isSharedQuery ? this.dataSourceShared = data.queries:  this.dataSource = data.queries;
      isSharedQuery ? this.totalSharedQueries = data.totalCount:  this.totalMyQueries = data.totalCount;
      this.creatingQuery = false;
      this.creatingSharedQuery = false;
    });
  }

  public changePageOptions({pageNumber, pageSize, myQueriesView}) {
    this.pageSize = pageSize;
    const queries$ = myQueriesView ?
      this.dataStudioService.getQueries(pageNumber, pageSize) :
      this.dataStudioService.getSharedQueries(pageNumber, pageSize);
    queries$.subscribe(data => {
      myQueriesView ? this.dataSource = data.queries:  this.dataSourceShared = data.queries;
    });
  }

  public searchForTitle({value, myQueriesView}) {
    const queries$ = myQueriesView ?
      this.dataStudioService.getQueries(0, this.pageSize, value) :
      this.dataStudioService.getSharedQueries(0, this.pageSize, value);
    queries$.pipe(take(1)).subscribe(data => {
      myQueriesView ? this.dataSource = data.queries:  this.dataSourceShared = data.queries;
      myQueriesView ? this.totalMyQueries = data.totalCount:  this.totalSharedQueries = data.totalCount;
    });
  }

  private getQueriesList(pageNumber = 0, pageSize = 10) {
    combineLatest([this.dataStudioService.getQueries(pageNumber, pageSize), this.dataStudioService.getSharedQueries(pageNumber, pageSize)])
    .pipe(take(1), tap(() => {
      this.totalMyQueries = null;
      this.totalSharedQueries = null;
      this.dataSource = [];
      this.dataSourceShared = [];
    }))
    .subscribe(([queries, sharedQueries]) => {
      this.totalMyQueries = queries.totalCount;
      this.totalSharedQueries = sharedQueries.totalCount;
      this.dataSource = queries.queries.sort((a, b) => b.queryNumber - a.queryNumber);
      this.dataSourceShared = sharedQueries.queries;
    });
  }
}
